const EMPTY_STOCKS = [];

export const getFollowedStocks = state => {
  const followedData = state.followed.data;

  if (!followedData) {
    return EMPTY_STOCKS;
  }

  if (!getFollowedStocks.lastSource || getFollowedStocks.lastSource !== followedData) {
    getFollowedStocks.lastSource = followedData;
    getFollowedStocks.lastResult = followedData.stocks.filter(
      stock => stock.user_stock.alerted === true
    );
  }

  return getFollowedStocks.lastResult;
};

getFollowedStocks.lastSource = null;
getFollowedStocks.lastResult = EMPTY_STOCKS;

export const getFollowedStocksLoading = state => {
  return state.followed.loading;
};

export const getUserStocks = state => state.followed.data;

export const getShouldRenderFollowedStocks = state =>
  state.followed.shouldRenderFollowedStocks;

export const getFollowedStocksMap = state => state.followed.followedStocksMap;

export const getAlertedTagDetails = state => state.followed.alertedTagDetails;

export const getStockIsFollowed = (state, stockId) => {
  const followedStocksMap = getFollowedStocksMap(state);

  return (
    followedStocksMap[stockId] &&
    followedStocksMap[stockId].active &&
    followedStocksMap[stockId].alerted
  );
};
